var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 91,
    viewBox: "0 0 95 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.1867 15.8711H11.8522C10.8629 15.8717 9.91418 16.265 9.21459 16.9646C8.515 17.6642 8.12171 18.6128 8.12109 19.6022V86.8873C8.12171 87.8767 8.515 88.8253 9.21459 89.5249C9.91418 90.2245 10.8629 90.6178 11.8522 90.6184H85.1867C86.1761 90.6179 87.1249 90.2247 87.8246 89.5251C88.5242 88.8255 88.9176 87.8767 88.9182 86.8873V19.6022C88.9176 18.6128 88.5242 17.6641 87.8246 16.9645C87.1249 16.2649 86.1761 15.8716 85.1867 15.8711Z",
    fill: "#8B8B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3587 67.2373H16.6803C14.6198 67.2373 12.9492 65.5667 12.9492 63.5062V4.05632C12.9492 1.9958 14.6198 0.325195 16.6803 0.325195H80.3587C82.4193 0.325195 84.0899 1.9958 84.0899 4.05632V63.5062C84.0899 65.5667 82.4193 67.2373 80.3587 67.2373Z",
    fill: "#F3F3F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1305 64.6871V5.23761C14.1305 3.17709 15.8011 1.50649 17.8616 1.50649H81.54C82.2678 1.50649 82.9444 1.71801 83.5181 2.07825C82.8585 1.02642 81.6918 0.325195 80.3587 0.325195H16.6803C14.6198 0.325195 12.9492 1.9958 12.9492 4.05632V63.5062C12.9492 64.8397 13.6504 66.0059 14.7023 66.6659C14.342 66.0919 14.1305 65.4153 14.1305 64.6875V64.6871Z",
    fill: "url(#paint0_linear_1705_6364)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5236 12.886H24.5156V15.6219H72.5236V12.886ZM72.5236 23.3327H24.5156V26.0686H72.5236V23.3327ZM72.5236 33.7817H24.5156V36.5176H72.5236V33.7817ZM72.5236 44.2284H24.5156V46.9647H72.5236V44.2284Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2383 35.3976L42.302 47.4617H30.2383V35.3976Z",
    fill: "url(#paint1_linear_1705_6364)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5743 50.9675L89.3725 87.7902C89.1125 89.6311 87.537 90.9993 85.678 90.9993H11.363C9.50398 90.9993 7.92854 89.6311 7.66847 87.7902L0.638899 38.0338C0.321807 35.7876 2.06485 33.7806 4.33342 33.7806H27.2835C29.1425 33.7806 30.7179 35.1488 30.978 36.9893L31.8992 43.5053C32.1593 45.3462 33.7347 46.7144 35.5937 46.7144H90.8806C93.1484 46.7144 94.8914 48.7213 94.5743 50.9675Z",
    fill: "url(#paint2_linear_1705_6364)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1458 74.5749H20.8998C20.597 74.5748 20.3046 74.4642 20.0774 74.264C19.8503 74.0638 19.7039 73.7876 19.6657 73.4872L18.9745 68.0146C18.9526 67.8395 18.9681 67.6618 19.02 67.4932C19.072 67.3246 19.1592 67.1689 19.2759 67.0366C19.3927 66.9043 19.5362 66.7982 19.697 66.7256C19.8577 66.653 20.0322 66.6153 20.2086 66.6152H76.837C77.0134 66.6153 77.1879 66.653 77.3486 66.7256C77.5094 66.7982 77.653 66.9043 77.7697 67.0366C77.8864 67.1689 77.9736 67.3246 78.0256 67.4932C78.0775 67.6618 78.093 67.8395 78.0711 68.0146L77.3799 73.4872C77.3417 73.7876 77.1953 74.0638 76.9682 74.264C76.741 74.4642 76.4486 74.5748 76.1458 74.5749Z",
    fill: "#EEEEEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1705_6364",
    x1: 50.7074,
    y1: 35.9651,
    x2: 3.52124,
    y2: -11.2215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1705_6364",
    x1: 38.2087,
    y1: 49.3974,
    x2: 23.6267,
    y2: 34.8158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1705_6364",
    x1: 47.6066,
    y1: 33.7806,
    x2: 47.6066,
    y2: 90.9993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#C5C5C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.3c66f3c76d0b13e7818bb6aa80c593cc.svg";
export { ForwardRef as ReactComponent };